import * as React from 'react';

export const ToDoMenuIcon = ({ ...props }: React.SVGProps<SVGSVGElement>) => (
  <svg
    style={props.style}
    width={props.width || '26'}
    height={props.height || '26'}
    fill={props.fill || 'none'}
    stroke={props.stroke || undefined}
    viewBox="0 0 24 27"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.3203 2.66406H6.65626V0H3.9922V2.66406H2.65626C2.3068 2.66406 1.96047 2.73321 1.63771 2.86719C1.31516 3.0011 1.02203 3.19706 0.775403 3.44434C0.528665 3.69182 0.333212 3.98641 0.200207 4.30957C0.0672744 4.63266 -0.00104034 4.97876 1.1975e-05 5.32812V24C1.50058e-05 24.7065 0.280691 25.3842 0.780285 25.8838C1.27988 26.3834 1.95755 26.6641 2.66407 26.6641H21.3281C22.0354 26.664 22.714 26.3831 23.2149 25.8838C23.7155 25.3845 23.9979 24.7071 24 24V5.32812C23.999 4.97723 23.9292 4.62944 23.794 4.30566C23.6588 3.98211 23.4606 3.68866 23.2119 3.44141C22.9631 3.19403 22.6674 2.99757 22.3428 2.86426C22.0184 2.73109 21.671 2.66305 21.3203 2.66406H19.9922V0H17.3203V2.66406ZM5.53907 16.8574L9.17872 20.2617L18.4668 11.5547L20.4424 13.4385L9.17872 23.998L3.55568 18.7178L5.53907 16.8574ZM21.3312 5.3328H2.66643V8.888H21.3312V5.3328Z"
      fill={props.fill || 'white'}
    />
  </svg>
);
